module.exports = __webpack_public_path__ + "img/4.e5f5855e.png";